import React from "react"

import { Action } from "shared/types/Action"

import { ProjectScopedActionHandlers } from "features/project-management/types/ProjectActionHandlers"

import { ProjectActionsOverlayView } from "./ProjectActionsOverlayView"
import { useProjectActionsOverlayViewModel } from "./hooks/useProjectActionsOverlayViewModel"

export interface ProjectActionsOverlayModel
  extends Partial<ProjectScopedActionHandlers> {
  additionalActions?: Action[]
  onCancel: () => void
}

export interface ProjectActionsOverlayProps extends ProjectActionsOverlayModel {
  isShared?: boolean
}

export const ProjectActionsOverlay = React.memo(
  (props: ProjectActionsOverlayProps) => (
    <ProjectActionsOverlayView {...useProjectActionsOverlayViewModel(props)} />
  )
)
